import styled from "styled-components";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";

export const FormActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x2}px;
  justify-content: flex-end;
  padding-top: ${spacing.x2}px;
  border-top: 1px solid ${colors.border};
`;

export const FormActionsStart = styled.div`
  margin-right: auto;
`;
